import ApiBase from "../api-base";
import axios from "axios";

class MeApi extends ApiBase {

    async me() {
        const response = await this.get('/users/me');
        return response.data.data;
    }


    async update(params, validationCallback = this.defaultValidationHandler) {
        const response = await this.post('/users/me', params, validationCallback);
        
        return response.data;
    }

    async notifications(params) {
        const response = await  this.get('/users/me/notifications');

        return response.data;
    }

    async upcomingBookings(params) {
        const response = await  this.get('/users/me/upcoming-bookings', params);

        return response.data;
    }

    async notificationsCount() {
        const response = await  this.get('/users/me/notifications/count');

        return response.data;
    }

    async uploadProfileImage(params) {
        const response = await axios.post('/api/connector/file-upload', params, null);

        return response.data;
    }

    async deleteProfileImage() {
        const response = await this.delete('/users/me/profile-image', {});
        
        return response.data;
    }

    async notificationsMarkAllRead() {
        const response = await this.post('/users/me/notifications/mark-all-read', {});
        return response.data.data;
    }

    async getConversations(params) {
        const response = await this.get('/users/me/conversations', params);

        return response.data;
    }

    async readConversationMessages(id) {
        const response = await this.post(`/users/me/conversations/${id}/messages/mark-all-read`, {});
        
        return response.data.data;
    }

    async getConversation(id) {
        const response = await this.get(`/users/me/conversations/${id}`);

        return response.data;
    }

    async getConversationMessages(id) {
        const response = await this.get(`/users/me/conversations/${id}/messages`);

        return response.data;
    }

    async createConversationMessage(id, params, validationCallback = this.defaultValidationHandler) {
        const response = await this.post(`/users/me/conversations/${id}/messages`, params, validationCallback);
        
        return response;
    }

    async createConversation(params, validationCallback = this.defaultValidationHandler) {
        const response = await this.post('/users/me/conversations', params, validationCallback);
        
        return response;
    }
}

export default new MeApi();
